import { Plane } from 'lucide-react';

// Coming-soon Leave tile. Realistic shape so the vital-signs row sits
// balanced today and hot-swaps to real data when HRMS access lands.

export const LeaveBalanceCard = () => (
  <div
    aria-disabled="true"
    className="group relative rounded-xl border border-dashed border-line bg-bg-secondary/50 p-3.5"
  >
    <span
      className="coming-soon-pulse absolute right-2 top-2 rounded-full bg-brand-orange/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-brand-orange"
      aria-label="Coming soon"
    >
      Coming soon
    </span>
    <div className="opacity-60">
      <div className="mb-3 flex items-center gap-2.5">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-text-tertiary/20 text-text-tertiary">
          <Plane className="h-4 w-4" aria-hidden="true" strokeWidth={2.25} />
        </div>
        <h3 className="text-[11px] font-semibold uppercase tracking-wider text-text-tertiary">
          Leave
        </h3>
      </div>
      <div className="space-y-2.5">
        <div className="flex items-baseline gap-2 leading-none">
          <span className="text-2xl font-semibold tabular-nums text-text-tertiary sm:text-3xl">—</span>
          <span className="text-xs text-text-tertiary">days left</span>
        </div>
        <div className="border-t border-line pt-2 text-[11px] text-text-tertiary">
          Pending: <span>—</span> · Next: <span>—</span>
        </div>
      </div>
    </div>
  </div>
);
